(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded', () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) { card.scrollIntoView({ behavior: 'instant' }); }
      },
      { once: true }
    );
  }

  function initCategoryTabs() {
    const tabs = document.querySelectorAll('[data-collection-handle]');
    const resultsList = document.querySelector('results-list');
    const newGrid = document.querySelector('.collection-wrapper');
    const currentGrid = resultsList.querySelector('.collection-wrapper');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const handle = tab.dataset.collectionHandle;

        // Active state
        tabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');

        const newUrl = `/collections/${handle}`;

        resultsList.classList.add('is-loading');

        fetch(newUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newContent = doc.querySelector('results-list');

            if (newContent && resultsList) {
              resultsList.style.opacity = '0';

              setTimeout(() => {
                resultsList.innerHTML = newContent.innerHTML;
                resultsList.style.opacity = '1';
                resultsList.classList.remove('is-loading');

                // 🔥 RE-INIT AFTER DOM UPDATE
                initCategoryTabs();
              }, 200);
            }
          });

        window.history.pushState({}, '', newUrl);
      });
    });
  }

document.addEventListener('DOMContentLoaded', () => {
  initCategoryTabs();
});

  } catch(e) { console.error(e); }
})();
})();
